import { __awaiter, __rest } from "tslib";
import * as React from 'react';
import { FORM_ERROR } from 'final-form';
import { useTranslation } from 'react-i18next';
import Login from './Login/Login';
import { useResponseErrorParser } from './hooks';
import ForgotPassword from './ForgotPassword/ForgotPassword';
import { useRenderers } from '../../../../renderProps';
import { LoginType, useCreateFfpAccountMutation, useFfpDefaultAccountQuery, useGetAccountInfoQuery } from '@websky/graphql';
import { useTheme } from '../../../../theme';
import { ApolloError } from 'apollo-boost';
import ModalConfirm from '../../../../ModalConfirm';
import Link from '../../../../Link';
import { Hello } from '../../../../Icons';
import { Сongratulations } from '../../../Icons';
import CreateAccountWithCheckbox from './CreateAccount/CreateAccountWithCheckbox/CreateAccountWithCheckbox';
export var ConnectType;
(function (ConnectType) {
    ConnectType["Login"] = "Login";
    ConnectType["Reset"] = "Reset";
    ConnectType["Create"] = "Create";
})(ConnectType || (ConnectType = {}));
const LoyaltyConnect = (_a) => {
    var _b, _c, _d;
    var { type: connectType = ConnectType.Login, isOpen, onClose, onDataLoading } = _a, props = __rest(_a, ["type", "isOpen", "onClose", "onDataLoading"]);
    const { t } = useTranslation('Loyalty');
    const { LoyaltyConnect: css } = useTheme('Loyalty');
    const [type, typeChange] = React.useState(connectType);
    const newAccFormRef = React.useRef(null);
    React.useEffect(() => {
        typeChange(isOpen ? connectType : null);
    }, [connectType, isOpen]);
    const { parseResponse } = useResponseErrorParser();
    const [error, setError] = React.useState(null);
    const [createAccountSuccess, setCreateAccountSuccess] = React.useState(false);
    const [createAccountLoading, setCreateAccountLoading] = React.useState(false);
    const [showSuccessCreateModal, setShowSuccessCreateModal] = React.useState(false);
    const { data, loading: isDefaultDataLoading } = useFfpDefaultAccountQuery();
    const { data: accountInfo, loading: accountInfoLoading } = useGetAccountInfoQuery({
        fetchPolicy: 'no-cache',
        skip: type !== ConnectType.Create
    });
    React.useEffect(() => {
        onDataLoading === null || onDataLoading === void 0 ? void 0 : onDataLoading(accountInfoLoading);
    }, [accountInfoLoading]);
    const [createAccountMutation] = useCreateFfpAccountMutation();
    const onError = (errors) => {
        const parseMessage = parseResponse(errors);
        setError(parseMessage);
        return { [FORM_ERROR]: parseMessage };
    };
    const createAccountRequest = (newFfpAccountData) => __awaiter(void 0, void 0, void 0, function* () {
        var _e, _f, _g;
        setCreateAccountLoading(true);
        try {
            const { data } = yield createAccountMutation({
                variables: {
                    params: newFfpAccountData
                }
            });
            if (!((_e = data === null || data === void 0 ? void 0 : data.CreateFfpAccount) === null || _e === void 0 ? void 0 : _e.result)) {
                // TODO: HACK fix it
                if (data.CreateFfpAccount.message === 'Сообщение программы: invalid FFP LK system') {
                    setCreateAccountSuccess(data.CreateFfpAccount.result);
                    setTimeout(() => typeChange(ConnectType.Login));
                    return undefined;
                }
                return onError([data.CreateFfpAccount]);
            }
            else {
                setShowSuccessCreateModal(true);
                setTimeout(() => typeChange(ConnectType.Login));
                setTimeout(() => setShowSuccessCreateModal(false), 5000);
                return undefined;
            }
        }
        catch (err) {
            setCreateAccountSuccess(false);
            if (err instanceof Error && err.message) {
                return onError([err]);
            }
            if (err instanceof ApolloError && ((_g = (_f = err.graphQLErrors) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.message)) {
                return onError(err.graphQLErrors);
            }
            return onError([{ message: 'Unknown error' }]);
        }
        finally {
            setCreateAccountLoading(false);
        }
    });
    const toCreateAccount = () => {
        if (props.showRegisterAction) {
            typeChange(ConnectType.Create);
        }
    };
    const toResetPassword = () => {
        typeChange(ConnectType.Reset);
    };
    const closeErrorHandler = () => setError(null);
    const hasConfirmedEmail = (_c = (_b = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.CurrentUser) === null || _b === void 0 ? void 0 : _b.authMethods) === null || _c === void 0 ? void 0 : _c.some(method => method.loginType === LoginType.Email && method.confirmed);
    const [isCreateAccountButtonDisabled, setIsCreateAccountButtonDisabled] = React.useState(false);
    const { CreateFfpAccountForm: CreateFfpAccountFormOverride = CreateAccountWithCheckbox } = useRenderers();
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalConfirm, { classes: { root: css.warning__modal }, title: t('Oops...'), size: "medium", isOpen: isOpen &&
                !accountInfoLoading &&
                !isDefaultDataLoading &&
                !hasConfirmedEmail &&
                type === ConnectType.Create, onClose: onClose, onCancel: onClose, confirmBtn: t('Fill email'), onConfirm: props.onGoToSettings }, t('To continue registering in the loyalty system, fill out and confirm your email in your personal account.')),
        React.createElement(ModalConfirm, { size: "medium", onClose: onClose, isOpen: isOpen && type === ConnectType.Create && hasConfirmedEmail, isLoading: createAccountLoading, title: React.createElement("div", { className: css.createTitle },
                React.createElement("div", null, Hello),
                React.createElement("div", null, t('Create account'))), confirmBtn: t('Create'), disableConfirmBtn: isCreateAccountButtonDisabled, buttonsExtra: React.createElement(React.Fragment, null,
                React.createElement(Link, { action: () => typeChange(ConnectType.Login) }, t('I have a card'))), onConfirm: () => {
                var _a;
                (_a = newAccFormRef.current) === null || _a === void 0 ? void 0 : _a.submit();
            }, scroll: "body" },
            React.createElement(CreateFfpAccountFormOverride, { initialValues: data, onCreateAccount: createAccountRequest, success: createAccountSuccess, toLogin: () => typeChange(ConnectType.Login), error: error, closeError: closeErrorHandler, formRef: newAccFormRef, isOpen: isOpen && type === ConnectType.Create && hasConfirmedEmail, onErrorsChanges: hasErrors => {
                    setIsCreateAccountButtonDisabled(hasErrors);
                } })),
        React.createElement(ModalConfirm, { className: css.login__modal_content, size: "medium", onClose: onClose, isOpen: isOpen && type === ConnectType.Login && !showSuccessCreateModal, hideFooter: true, hideTitle: true },
            React.createElement(Login, { onLoyaltyCardSaved: props.onLoyaltyCardSaved, toCreateAccount: toCreateAccount, toResetPassword: toResetPassword, showRegisterAction: props.showRegisterAction, queryType: props.authType })),
        React.createElement(ModalConfirm, { size: "medium", onClose: onClose, isOpen: isOpen && type === ConnectType.Reset, hideFooter: true, hideTitle: true },
            React.createElement(ForgotPassword, { toLogin: () => typeChange(ConnectType.Login), email: (_d = props.userInfo) === null || _d === void 0 ? void 0 : _d.email })),
        React.createElement(ModalConfirm, { classes: { content: css.createSuccess__modal_content }, size: "medium", onClose: () => setShowSuccessCreateModal(false), onConfirm: () => setShowSuccessCreateModal(false), confirmBtn: t('Login'), isOpen: isOpen && type === ConnectType.Login && showSuccessCreateModal, title: React.createElement("div", { className: css.createSuccess__modal_titleWrapper },
                React.createElement("span", null, Сongratulations),
                React.createElement("span", { className: css.createSuccess__modal_title }, t('Congratulations on your successful registration!'))) },
            React.createElement("div", null, t('The card number and password have been sent by e-mail')))));
};
export default LoyaltyConnect;
